<template>
  <header class="container-float flex d-flex justify-content-between align-items-center">
    <a
      class="native-hash"
      :href="nativeHashLink"
      target="_blank"
    >
      <img :src="$publicPath + 'img/logo-black.svg'">
    </a>

    <div class="d-inline-flex align-items-center user-part">
      <div
        v-if="showLangSwitch"
        class="lng"
      >
        <lang-switch class="d-inline-block" />
      </div>
      <div class="user">
        <router-link
          :to="{name: 'profile'}"
        >
          <img :src="avatarPath">
          <span>{{ $store.state.user.profile.name }}</span>
        </router-link>
      </div>
      <div class="icons">
        <!-- <a href="#">
          <img :src="$publicPath + 'img/header-nav-icons/messages.svg'">
        </a>
        <a href="#">
          <img :src="$publicPath + 'img/header-nav-icons/notifications.svg'">
        </a> -->
        <router-link
          :to="{name: 'settings'}"
        >
          <img :src="$publicPath + 'img/header-nav-icons/settings.svg'">
        </router-link>
      </div>
      <b-button
        v-if="$store.getters['auth/isAuthenticated']"
        class="d-none d-md-inline-block"
        variant="logout"
        @click="logout"
      >
        {{ $t('layout-header.logout') }}
      </b-button>
    </div>
    <div class="w-100 d-md-none d-flex justify-content-between mt-4 mb-2">
      <a
        class="ml-4"
        href="#"
        @click="toggleMenu"
      >
        <img :src="$publicPath + 'img/menu.svg'">
      </a>
      <b-button
        v-if="$store.getters['auth/isAuthenticated']"
        variant="logout"
        @click="logout"
      >
        {{ $t('layout-header.logout') }}
      </b-button>
    </div>
  </header>
</template>

<script>
import LangSwitch from './LangSwitch.vue'

export default {
  components: {
    'lang-switch': LangSwitch
  },
  computed: {
    nativeHashLink () {
      return process.env.VUE_APP_NATIVEHASH_URL
    },
    avatarPath () {
      return this.$store.state.user.profile.avatar ? this.$store.state.user.profile.avatar : this.$publicPath + 'img/default-avatar.svg'
    },
    showLangSwitch () {
      return window.location.hostname === 'localhost'
    }
  },
  methods: {
    logout (e) {
      this.$store.dispatch('auth/logout')
        .then(() => {
          this.$flash.success(this.$t('layout-header.logout.message'))
          this.$router.push({ name: 'login' }).catch(() => {})
        })
        .catch(() => {})
    },
    toggleMenu (e) {
      this.$store.dispatch('mobileMenu/toggle')
    }
  }
}
</script>

<style lang="scss" scoped>
  header {
    height: 83px;
    background-color: white;
    border: 2px solid #F7F7F7;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 2;
    @include media-breakpoint-down(sm) {
      position: initial;
      flex-wrap: wrap;
      height: auto;
      padding-bottom: 0.75rem;
    }
  }
  .native-hash {
    padding: 0.5rem 2rem;
    color: #fff;
    display: inline-block;
    font-size: 1.25rem;
    line-height: inherit;
    white-space: nowrap;
    @include media-breakpoint-down(sm) {
      width: 100%;
      text-align: center;
      margin-bottom: 0.5rem;
    }
    img {
      max-height: 2.3rem;
    }
  }
  .user-part {
    @include media-breakpoint-down(sm) {
      width: 100%;
      justify-content: center;
      margin-top: 0.75rem;
    }
  }
  .user {
    margin: 0 1.5rem;
    display: inline-flex;
    align-items: center;
    img {
      margin-right: 0.75rem;
      width: 36px;
      height: 36px;
      border-radius: 100%;
    }
    span {
      display: inline-block;
      font-size: 0.938rem;
    }
    a {
      &:hover {
        color: inherit
      }
    }
  }
  .lng {
    margin: 0 1rem;
    display: inline-block;
  }
  .icons {
    margin: 0 1rem;
    a {
      margin: 0 1rem;
      display: inline-block;
      &:hover {
        transform: scale(1.2);
      }
    }
    img {
      min-width: 19px;
      max-width: 22px;
    }
  }
  .btn-logout {
    background-color: #f3f3f3;
    border: none;
    border-radius: 6px;
    font-size: 0.688rem;
    font-weight: bold;
    color: black;
    padding: 0.75rem 1.2rem;
    padding-right: 2.2rem;
    text-transform: uppercase;
    background-image: url('./../assets/img/logout.svg');
    background-repeat: no-repeat;
    background-position: center right 0.625rem;
    opacity: 0.65;
    transition: 0.2s;
    outline: none;
    margin-right: 2rem;
    &:hover {
      opacity: 1;
    }
    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
</style>
